import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface GasTankProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function GasTank(props: GasTankProps) {
  return (
    <svg
      width="118"
      height="152"
      viewBox="0 0 118 152"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 175, right: 29}}
      onClick={props.onClick}
    >
      <path
        d="M86 1C86 1 99 1.00049 99 14V38H111C114.314 38 117 40.6863 117 44C117 47.3135 114.314 50 111 50H99V102H111C114.314 102 117 104.686 117 108C117 111.314 114.314 114 111 114H99V138C99 151 86 151 86 151H32C32 151 19 151 19 138V114H7C3.68643 114 1.00023 111.314 1 108C1 104.686 3.68629 102 7 102H19V50H7C3.68643 50 1.00023 47.3135 1 44C1 40.6863 3.68629 38 7 38H19V14C19 1.00049 32 1 32 1H86Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <rect
        x="89"
        y="42.0001"
        width="4"
        height="60"
        rx="2"
        transform="rotate(90 89 42.0001)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="89"
        y="26.0001"
        width="4"
        height="60"
        rx="2"
        transform="rotate(90 89 26.0001)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="89"
        y="58.0001"
        width="4"
        height="60"
        rx="2"
        transform="rotate(90 89 58.0001)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="89"
        y="74.0001"
        width="4"
        height="60"
        rx="2"
        transform="rotate(90 89 74.0001)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="89"
        y="90.0001"
        width="4"
        height="60"
        rx="2"
        transform="rotate(90 89 90.0001)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="89"
        y="106"
        width="4"
        height="60"
        rx="2"
        transform="rotate(90 89 106)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="89"
        y="122"
        width="4"
        height="60"
        rx="2"
        transform="rotate(90 89 122)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M99 138V75.9996V13.9995C99 1 86 1 86 1L59 1.00006L32 1C32 1 19 1 19 13.9995V75.9996V138C19 151 32 151 32 151L59 151L86 151C86 151 99 151 99 138Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="7"
        cy="43.9996"
        r="2"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M1 43.9996C1 47.3133 3.68629 49.9996 7 49.9996H19V37.9996H7C3.68629 37.9996 1 40.6859 1 43.9996Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="7"
        cy="108"
        r="2"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M1 108C1 111.313 3.68629 114 7 114H19V102H7C3.68629 102 1 104.686 1 108Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="2"
        cy="2"
        r="2"
        transform="matrix(-1 0 0 1 113 41.9996)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M117 43.9996C117 47.3133 114.314 49.9996 111 49.9996H99V37.9996H111C114.314 37.9996 117 40.6859 117 43.9996Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="2"
        cy="2"
        r="2"
        transform="matrix(-1 0 0 1 113 106)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M117 108C117 111.313 114.314 114 111 114H99V102H111C114.314 102 117 104.686 117 108Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
    </svg>
  );
}
